import React from 'react';
import { Button, Badge, Modal } from "react-bootstrap";
import rice from '../../../../images/raw_material/rice.png';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import axios from 'axios'; // new 
import raw from '../../../../images/raw_material/else.jpg';
 

const Raw_Material_View = ({ show, onClose, isAutoPurchase, data }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    if (!data) return null; // new line 
    console.log('Raw Material Data:', data);

    return (
        <Modal show={show} size="lg" >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">View Raw Material</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-4'> 
                            <div className="d-flex mb-2 align-items-center justify-content-start gap-3 mt-2">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={data.image_url || raw} className='border  w-120px h-130px rounded px-1 py-1 mt-n3'>
                                        <img src={data.image_url || raw} alt="Break Box" className='cursor-pointer ' style={{width:'120px', height:'125px'}} />
                                    </div>
                                </LightGallery>
                            </div>
                        </div>
                        <div className='col-lg-8'>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Raw Material</label>
                                    <label className='text-black fs-6 font-w500'>{data.rawmaterial_name}</label>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Category</label>
                                    <label className='text-black fs-6 font-w500'>{data.rawmaterial_category_name}</label>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Brand</label>
                                    <label className='text-black fs-6 font-w500'>{data.brand_name}</label>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Quantity / Units</label>
                                    <label className='text-black fs-6 font-w500'>{data.rawmaterial_quantity} {data.rawmaterial_unit_name}</label>
                                </div>
                                 <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Packed GST</label>
                                    <label className='text-black fs-6 font-w500'>{data.packed_gst_value} %</label>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Unpacked GST</label>
                                    <label className='text-black fs-6 font-w500'>{data.unpacked_gst_value} %</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column  mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Expiry Period</label>
                            <div>
                                <Badge bg="warning" className='text-white fs-8 py-0 px-1'>{data.expiry_period} Days</Badge>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12  d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Base Cost</label>
                            <p className="text-info fs-6 m-0 font-w500">
                                <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                <span>{new Intl.NumberFormat('en-IN').format(data.base_cost)} /-</span>
                            </p>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Minimum Stock Level</label>
                            <div>
                                <Badge bg="danger" className='text-white fs-8 py-0 px-1'>{data.minimum_stock_level} {data.rawmaterial_unit_name}</Badge>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Maximum Stock Level</label>
                            <div>
                                <Badge bg="success" className='text-white fs-8 py-0 px-1'>{data.maximum_stock_level} {data.rawmaterial_unit_name}</Badge>
                            </div>
                        </div>
                           <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Storage Room Name</label>
                            <div>
                                <Badge bg="info" className='text-white fs-8 py-0 px-1'>{data.room_type_name}</Badge>
                            </div>
                        </div>
                         <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Auto Purchase</label>
                            <div className="form-check form-switch d-flex align-items-center mb-3">
                                <input
                                    className="form-check-input me-2"
                                    type="checkbox"
                                    role="switch"
                                    checked={data.auto_purchase === 0} // ✅ Custom logic applied here
                                    readOnly // Optional: to prevent user changes in view mode
                                />
                            </div>
                        </div>
                        <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Description</label>
                            <label className='text-black fs-6 font-w500'>&emsp;&emsp; {data.description}</label>
                        </div>
                    </div>

                     
 
                </div>
            </div>
        </Modal >
    );
};

export default Raw_Material_View;
